<script lang="ts">
    import { Form } from "svelte-forms-lib";
    import { Button, Col, FormGroup, Input, Label } from "sveltestrap";
    import {  Birthdate, City, Email, Finish, FirstName, HavePassport, LastName, Next, Password, State, Step, href,  } from "../../../../utils/Constant/Constant";
    import {stepwizarddata} from "../../../../Data/Forms/FormLayout/FormWizard"
    import {selectId} from "../../../../store"
    let lName:string , newEmail:string , fName:string , newPassword:string, newDate:string, newSelect:string ,newState:string , newCity:string
    let setSelectId:string
    const handleContent =(id:string)=> {
        if(setSelectId === "step-4" && newState != "" && newCity != ""){
            alert("Successfully Login")
            selectId.update(value => value = id)
            lName = "", newEmail = "" , fName = "" , newPassword = "", newDate = "", newSelect = "" ,newState = "" , newCity = ""
        }
        else{
            selectId.update(value => value = id)
        }
    }
    selectId.subscribe((value)=>{
        setSelectId = value
    })
</script>
<div class="stepwizard">
    <div class="stepwizard-row setup-panel">
        {#each stepwizarddata as formItem}
            <div class="stepwizard-step">
                <Button color={setSelectId === formItem.id ? "light" : "primary"} href={href} on:click={()=>handleContent(formItem.id)}>{formItem.num}</Button>
                <p>{Step} {formItem.num}</p>
            </div>
        {/each}
    </div>
</div>
<Form action="#" method="POST">
    <div class="setup-content {setSelectId === "step-1" ? "d-block" :"d-none"}" id="step-1">
      <Col xs="12">
            <Col md="12">
                <FormGroup>
                    <Label class="control-label">{FirstName}</Label>
                    <Input type="text" name="Johan" placeholder="Johan" required bind:value={fName} />
                </FormGroup>
                <FormGroup>
                    <Label class="control-label">{LastName}</Label>
                    <Input type="text" name="Deo" placeholder="Deo" required bind:value={lName} />
                </FormGroup>
                <Button type="button" color="primary" class="nextBtn pull-right" on:click={()=>handleContent("step-2")}>{Next}</Button>
            </Col>
      </Col>
    </div>
    <div class="setup-content {setSelectId === "step-2" ? "d-block" :"d-none"}" id="step-2">
      <Col xs="12">
            <Col md="12">
                <FormGroup>
                    <Label class="control-label">{Email}</Label>
                    <Input type="text" name="email" bind:value={newEmail} placeholder="name@example.com" required />
                </FormGroup>
                <FormGroup>
                    <Label class="control-label">{Password}</Label>
                    <Input type="password" name="password" bind:value={newPassword} placeholder="Password" required/>
                </FormGroup>
                <Button type="button" color="primary" class="nextBtn pull-right" on:click={()=>handleContent("step-3")}>{Next}</Button>
            </Col>
      </Col>
    </div>
    <div class="setup-content {setSelectId === "step-3" ? "d-block" :"d-none"}" id="step-3">
      <Col xs="12">
            <Col md="12">
                <FormGroup>
                    <Label class="control-label">{Birthdate}</Label>
                    <Input type="date" name="date" required bind:value={newDate} />
                </FormGroup>
                <FormGroup>
                    <Label class="control-label">{HavePassport}</Label>
                    <Input type="text" name="yes/no" placeholder="yes/No" required bind:value={newSelect}/>
                </FormGroup>
                <Button type="button" color="primary" class="nextBtn pull-right" on:click={()=>handleContent("step-4")}>{Next}</Button>
            </Col>
      </Col>
    </div>
    <div class="setup-content {setSelectId === "step-4" ? "d-block" :"d-none"}" id="step-4">
        <Col xs="12">
            <Col md="12">
                <FormGroup>
                    <Label class="control-label">{State}</Label>
                    <Input class="mt-1" name="state" type="text" placeholder="State"  bind:value={newState} required/>
                </FormGroup>
                <FormGroup>
                    <Label class="control-label">{City}</Label>
                    <Input class="mt-1" name="city" type="text" placeholder="City" bind:value={newCity} required/>
                </FormGroup>
                <Button type="button" color="secondary" class="pull-right" on:click={()=>handleContent("step-1")}>{Finish}!</Button>
            </Col>
        </Col>
    </div>
</Form>

